import { z } from "zod";
import { isoDateSchema, objectIdSchema, roleEnum } from "./common";
export const teamSchema = z.object({
    _id: objectIdSchema,
    name: z.string().min(1).max(120),
    ownerId: objectIdSchema,
    createdAt: isoDateSchema,
});
export const teamMemberSchema = z.object({
    _id: objectIdSchema,
    teamId: objectIdSchema,
    userId: objectIdSchema,
    role: roleEnum,
    createdAt: isoDateSchema,
});
export const createTeamSchema = z.object({ name: z.string().min(1).max(120) });
export const inviteTeamMemberSchema = z.object({
    email: z.string().email(),
    role: roleEnum.exclude(["OWNER"]),
});
//# sourceMappingURL=team.js.map